<template>
    <div class="card tour-static-card">
        <div class="card-header">
            <div class="tour-static-image" :style="'background-image: url(./assets/images/backgrounds/centralpark.jpg)'"></div>
        </div>
        <div class="card-body text">
            <div class="tour-static-title">Central Park</div>
            <p>Is larger than the principality of Monaco. Since 1908, Central Park has appeared in ouer 240 feature films.</p>
        </div>
    </div>
</template>

<script>
import FareHarborMixin from "../../mixins/FareHarborMixin";
export default {
    name: "TourStaticBlock",
    mixins: [FareHarborMixin]
}
</script>
